export const FAMILY_TYPE_SINGLE = 0
export const FAMILY_TYPE_COUPLE = 1
export const FAMILY_TYPE_SINGLE_WITH_CHILDREN = 2
export const FAMILY_TYPE_COUPLE_WITH_CHILDREN = 3